import React from 'react';
import DeviceDOMCanvas from '../DeviceDOMCanvas/DeviceDOMCanvas';
import Devices from '../Devices/Devices';
import Schedules from '../Schedules/Schedules';
import ErrorBoundary from '../../utils/error-boundary';
import OrderForm from '../Schedules/OrderForm';
import StatusBar from '../../components/StatusBar/StatusBar';
import BatchMaterial from '../Materials/BatchMaterial';
import Diagnose from '../Diagnose/Diagnose';
import { isTouchScreen } from '../../utils/is-touch-screen';
import Washout from '../Batch/Washout';
import TestMode from '../Batch/TestMode';
import LogicEditor from '../../modules/logicEditor/components/LogicEditor';
import { ConfirmFinishBatch } from '../../components/Confirm/ConfirmFinishBatch';

export default () => (
  <div className="page-content">
    <ErrorBoundary>
      <BatchMaterial/>
      <Washout/>
      <Devices/>
      <DeviceDOMCanvas/>
      <Schedules/>
      <OrderForm/>
      <StatusBar/>
      {!isTouchScreen() && <LogicEditor />}
      <Diagnose/>
      <TestMode/>
      <ConfirmFinishBatch />
    </ErrorBoundary>
  </div>
);
